module.exports = __webpack_public_path__ + "static/media/googleplay_btn.f9303443.png";